<template>
    <div>
        <h2 class="mt-20 tracking-wider font-bold text-center text-3xl">
            <span v-if="isGerman">Projekte</span>
            <span v-else>Projects</span>
        </h2>

        <div class="p-10 mt-5 grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1">
            <div
                v-for="project in projects"
                :key="projectKey(project.image)"
                class="p-6"
            >
                <router-link :to="`/show-project/${project.title}/${project.component}`">
                    <div class="shadow-2xl cursor-pointer overflow-hidden hover:shadow-custom-2xl hover:-my-4 transition-margin duration-300 ease-in-out">
                        <!-- <div class="shadow-2xl cursor-pointer rounded-b-md overflow-hidden hover:shadow-custom-2xl hover:-my-4 transition-margin duration-300 ease-in-out"> -->
                        <tailwind-image
                            :link="project.image"
                            :alt="project.title"
                            aspect-ratio="2/3"
                            class="overflow-hidden"
                        ></tailwind-image>
                        <!-- <tailwind-image
                            :link="project.image"
                            :alt="project.title"
                            aspect-ratio="2/3"
                            class="rounded-t-2xl overflow-hidden"
                        ></tailwind-image> -->
                        <p class="text-center font-semibold py-3 px-5 truncate">{{project.title}}</p>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {
        isGerman: {
            type: Boolean,
            default: true,
        }
    },
    data ()
    {
        return {
            projects: [
                {
                    title: 'Sportlerheim Herschbach',
                    image: require( '@/assets/img/phone/_DSC1287.jpg' ),
                    component: 'P029',
                },
                {
                    title: 'CURV 500®  Portables Lautsprechersystem',
                    image: require( '@/assets/img/phone/curv_19_a.jpg' ),
                    component: 'P002',
                },
                {
                    title: 'DENTALFIT Koblenz',
                    image: require( '@/assets/img/phone/dentalfit_15_a.jpg' ),
                    component: 'P003',
                },
                {
                    title: 'ECHOLOT PAVILLON BUNDESGARTENSCHAU Koblenz',
                    image: require( '@/assets/img/phone/Innen22.jpg' ),
                    component: 'P004',
                },
                {
                    title: 'ECHOLOT Campus Koblenz',
                    image: require( '@/assets/img/phone/2012-09-06 (FF 21) Montage Holzelemente.jpg' ),
                    component: 'P005',
                },
                {
                    title: 'ENGELSTROMPETE Luminale Frankfurt am Main',
                    image: require( '@/assets/img/phone/DSC_4361.jpg' ),
                    component: 'P007',
                },
                {
                    title: 'ENGELSTROMPETE Offenbach',
                    image: require( '@/assets/img/phone/Halle_Leer 084.jpg' ),
                    component: 'P006',
                },
                {
                    title: 'RECHENZENTRUM MAIN CUBE EVO Offenbach ',
                    image: require( '@/assets/img/phone/maincube_1.jpg' ),
                    component: 'P008',
                },
                {
                    title: 'Generatives Relief',
                    image: require( '@/assets/img/phone/relief_1.jpg' ),
                    component: 'P009',
                },
                {
                    title: 'Haus Kräutchesgarten',
                    image: require( '@/assets/img/phone/1.jpg' ),
                    component: 'P010',
                },
                {
                    title: 'HEWI - Die Schubladen Bauwerk Köln',
                    image: require( '@/assets/img/phone/_DSC1157.jpg' ),
                    component: 'P011',
                },
                {
                    title: 'IMM - Köln',
                    image: require( '@/assets/img/phone/hfg_of110122_01k.jpg' ),
                    component: 'P012',
                },
                {
                    title: 'Kantine Griesson',
                    image: require( '@/assets/img/phone/kantine_2.jpg' ),
                    component: 'P013',
                },
                {
                    title: 'Generative Lamellenstruktur',
                    image: require( '@/assets/img/phone/peel_1.jpg' ),
                    component: 'P014',
                },
                {
                    title: 'Rechenzentrum Kaiserslautern',
                    image: require( '@/assets/img/phone/Rendering RZ Vorderseite 20.08.2009.jpg' ),
                    component: 'P015',
                },
                {
                    title: 'Sakralbau',
                    image: require( '@/assets/img/phone/Sakralbau_2_a.jpg' ),
                    component: 'P016',
                },
                {
                    title: 'Soundwave',
                    image: require( '@/assets/img/phone/soundfield_4.jpg' ),
                    component: 'P017',
                },
                {
                    title: 'Vallendar Studentenwohnheim',
                    image: require( '@/assets/img/phone/studentenwohnheimvallendar_1.jpg' ),
                    component: 'P018',
                },
                {
                    title: 'VITRA Corpform',
                    image: require( '@/assets/img/phone/Bild 12 Vitra-Corpform-1 Entry WAZ.jpg' ),
                    component: 'P019',
                },
                {
                    title: 'Weingut Löwenstein Fassade Winningen',
                    image: require( '@/assets/img/phone/weingutloewenstein_1.jpg' ),
                    component: 'P020',
                },
                {
                    title: 'Wettbewerb SozialSchnellGut',
                    image: require( '@/assets/img/phone/sozialschnellgut_1_a.jpg' ),
                    component: 'P021',
                },
                {
                    title: 'Hybrid',
                    image: require( '@/assets/img/phone/Hybrid-D-7.jpg' ),
                    component: 'P022',
                },
                {
                    title: 'Kino Kunsthalle Darmstadt',
                    image: require( '@/assets/img/phone/kino_kunsthalle_3_a.jpg' ),
                    component: 'P023',
                },
                // {
                //     title: 'Leitstand Kalkwerk',
                //     image: require( '@/assets/img/phone/Ansicht Leitstand2.jpg' ),
                //     component: 'P024',
                // },
                {
                    title: 'Multipurposehall Bergen-Norwegen',
                    image: require( '@/assets/img/phone/hinten nacht.jpg' ),
                    component: 'P025',
                },
                // {
                //     title: 'Oraniencenter Diez',
                //     image: require( '@/assets/img/phone/1fertig.jpg' ),
                //     component: 'P026',
                // },
                {
                    title: 'Parametrisierte Schale',
                    image: require( '@/assets/img/phone/schale_1_a.jpg' ),
                    component: 'P027',
                },
                {
                    title: 'Paul-Adaptive Gebäudehülle ILEK Stuttgart',
                    image: require( '@/assets/img/phone/paul_74.jpg' ),
                    component: 'P028',
                },
                {
                    title: 'COCOS Frankfurt am Main',
                    image: require( '@/assets/img/phone/cocos_4.jpg' ),
                    component: 'P001',
                },
                {
                    title: 'Werkkino de Beukelaer - Ravensburg',
                    image: require( '@/assets/img/phone/Kino Ravensburg.jpg' ),
                    component: 'P030',
                },
                {
                    title: 'Wettbewerb Alter Markt - Hachenburg',
                    image: require( '@/assets/img/phone/Plan 3-1.jpg' ),
                    component: 'P031',
                },
                {
                    title: 'Wettbewerb Soonwald Baumwipfelpfad',
                    image: require( '@/assets/img/phone/Bild1.jpg' ),
                    component: 'P032',
                },
                {
                    title: 'Wettbewerb Graz-Liebenau',
                    image: require( '@/assets/img/phone/PICT0015.jpg' ),
                    component: 'P033',
                },
                // {
                //     title: 'Wettbewerb - Höhn',
                //     image: require( '@/assets/img/phone/1001-Fasadenschnitt.jpg' ),
                //     component: 'P034',
                // },
                {
                    title: 'Zacherlfabrik - Wien',
                    image: require( '@/assets/img/phone/Dahlberg-10.jpg' ),
                    component: 'P035',
                },
            ],
        };
    },
    methods: {
        projectKey ( image )
        {
            return `project-${ image }`;
        }
    },
    created () { },
};
</script>